import { canUseDOM } from 'exenv';
import extend from 'lodash/extend';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import map from 'lodash/map';
import identityConfig from '../../../config/identity';
import { figureOutPriorityTag } from '../../../utils/ad_util';

export default function loadOmnitureTracker(currentState, pageNumber = 1) {
  if (window.fastco_s) {
    const siteConfig = identityConfig;
    const siteSlug = get(siteConfig, 'slug');
    const context = get(currentState, 'context');

    const {
      postData,
      tagPageData,
      categoryPageData,
      authorPageData,
      searchPageData,
      staticPageData,
      mostCreativePeoplePageData,
      personPageData,
      ibdPageData,
      companyPageData,
      micPageData,
      micSectorPageData,
      videoPageData,
      playlistAllFeedData,
      productPageData,
      type,
      supertags
    } = context;

    let category = '';
    let tag = '';
    // Omniture data structure, defaults to homepage value
    // it will be further extended depend on page type
    let omniture = {
      server: siteSlug,
      channel: 'homepage',
      pageName: `${siteSlug}:homepage:front`,
      pageURL: get(siteConfig, 'url'),
      events: 'event9',
      prop1: '',
      prop2: '',
      prop3: '',
      prop4: get(siteConfig, 'url'),
      prop5: '',
      prop6: '',
      prop7: '',
      prop8: '',
      prop9: '',
      prop10: '',
      prop11: '',
      prop13: pageNumber,
      prop21: 'anonymous',
      prop22: `anonymous:${siteSlug}:homepage:front`,
      prop23: 'anonymous',
      prop28: '',
      prop31: '',
      prop32: '',
      prop33: '',
      eVar49:
        document.cookie.split('; ').filter(c => /abgroup=/.test(c))[0] &&
        document.cookie
          .split('; ')
          .filter(c => /abgroup=/.test(c))[0]
          .includes('abgroup=')
          ? document.cookie
              .split('; ')
              .filter(c => /abgroup=/.test(c))[0]
              .toString()
              .replace('abgroup=', '')
          : undefined
    };

    const typeLookup = {
      post() {
        category = get(postData, 'categories[0].slug');
        const tags = get(postData, 'tags');
        const eyeBrowText = figureOutPriorityTag(tags, supertags);
        const postID = get(postData, 'id');
        const postSlug = get(postData, 'slug');

        let pageType = 'article';
        if (get(postData, 'posterSlideshow.length')) {
          pageType = 'slideshow';
        } else if (
          get(postData, 'hasVideoPoster') === true ||
          get(postData, 'posterVideo.feedId')
        ) {
          pageType = 'video';
        }

        // Extend original omniture variable
        omniture = extend({}, omniture, {
          pageName: `${siteSlug}:${postID}:${postSlug}`,
          pageURL: `${get(siteConfig, 'url')}/${postID}/${postSlug}`,
          channel: '',
          prop1: category,
          prop2: category,
          prop3: get(postData, 'title'),
          prop4: get(postData, 'link'),
          prop5:
            get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc',
          prop6:
            get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc',
          prop7: '',
          prop8: get(postData, 'author.name'),
          prop9: get(postData, 'omnitureDate'),
          prop10: postID,
          prop11: get(postData, 'author.name'),
          prop13: pageNumber,
          prop22: `anonymous:${siteSlug}:${postID}:${postSlug}`,
          prop28: pageType,
          prop31: '',
          prop32: '',
          prop33: capitalize(category)
        });
      },
      category() {
        category = get(categoryPageData, 'slug', '');
        omniture = extend({}, omniture, {
          channel: category,
          pageName: `${siteSlug}:${category}:front`,
          pageURL: `${get(siteConfig, 'url')}/${category}`,
          url: `${get(siteConfig, 'url')}/${category}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/${category}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:${category}:front`,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      tag() {
        tag = get(tagPageData, 'slug', '');
        omniture = extend({}, omniture, {
          channel: tag,
          pageName: `${siteSlug}:taxonomy:${tag}`,
          pageURL: `${get(siteConfig, 'url')}/section/${tag}`,
          url: `${get(siteConfig, 'url')}/section/${tag}`,
          prop1: '',
          prop2: '',
          prop3: get(tagPageData, 'name'),
          prop4: `${get(siteConfig, 'url')}/section/${tag}`,
          prop5: tag,
          prop6: tag,
          prop7: '',
          prop8: 'Fast Company Contributor',
          prop9: '',
          prop10: '',
          prop11: 'Fast Company Contributor',
          prop22: `anonymous:${siteSlug}:taxonomy:${tag}`,
          prop28: 'tag',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      author() {
        const authorSlug = get(authorPageData, 'slug', 'fastcompany-staff');
        const authorName = get(authorPageData, 'name', 'Fastcompany Staff');
        omniture = extend({}, omniture, {
          channel: '',
          pageName: `${siteSlug}:user:${authorSlug}`,
          pageURL: `${get(siteConfig, 'url')}/user/${authorSlug}`,
          url: `${get(siteConfig, 'url')}/user/${authorSlug}`,
          prop1: '',
          prop2: '',
          prop3: authorName,
          prop4: `${get(siteConfig, 'url')}/user/${authorSlug}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: authorName,
          prop9: '',
          prop10: '',
          prop11: authorName,
          prop22: `anonymous:${siteSlug}:user:${authorSlug}`,
          prop28: 'user',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      search() {
        const searchQuery = get(searchPageData, 'query.queryString', '');
        omniture = extend({}, omniture, {
          channel: '',
          pageName: `${siteSlug}:search:${searchQuery}`,
          pageURL: `${get(siteConfig, 'url')}/search/${searchQuery}`,
          prop1: '',
          prop2: '',
          prop3: searchQuery,
          prop4: `${get(siteConfig, 'url')}/search/${searchQuery}`,
          prop5: searchQuery,
          prop6: searchQuery,
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:search:${searchQuery}`,
          prop28: 'search',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      page() {
        const pageSlug = get(staticPageData, 'slug', '');
        omniture = extend({}, omniture, {
          channel: '',
          pageName: `${siteSlug}:page:${pageSlug}`,
          pageURL: `${get(siteConfig, 'url')}/${pageSlug}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/${pageSlug}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:page:${pageSlug}`,
          prop28: 'page',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      personPage() {
        const personSlug = get(personPageData, 'data.rows[0].url');
        omniture = extend({}, omniture, {
          channel: 'mcp',
          pageName: `${siteSlug}:person:${personSlug}`,
          pageURL: `${get(siteConfig, 'url')}/person/${personSlug}`,
          url: `${get(siteConfig, 'url')}/person/${personSlug}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/person/${personSlug}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:person:${personSlug}`,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      personIndexSectionPage() {
        omniture = extend({}, omniture, {
          channel: 'person',
          pageName: `${siteSlug}:person-index`,
          pageURL: `${get(siteConfig, 'url')}/person`,
          url: `${get(siteConfig, 'url')}/person`,
          prop1: '',
          prop2: '',
          prop3: 'Person Index',
          prop4: `${get(siteConfig, 'url')}/person`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:person-index`,
          prop28: 'person',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      mostCreativePeoplePage() {
        const year = get(mostCreativePeoplePageData, 'year', '');
        omniture = extend({}, omniture, {
          channel: 'mcp',
          pageName: year ? `${siteSlug}:mcp:${year}` : `${siteSlug}:mcp:front`,
          pageURL: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
          url: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
          prop1: '',
          prop2: '',
          prop3: `MCP LIST ${year}`,
          prop4: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:page:mcp:${year}`,
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      mostCreativePeopleCommunityPage() {
        omniture = extend({}, omniture, {
          channel: 'MCP',
          pageName: `${siteSlug}:most-creative-people-community`,
          pageURL: `${get(siteConfig, 'url')}/most-creative-people-community`,
          url: `${get(siteConfig, 'url')}/most-creative-people-community`,
          prop1: '',
          prop2: '',
          prop3: 'Most Creative People Community Page',
          prop4: `${get(siteConfig, 'url')}/most-creative-people-community`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:mcp:community`,
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      ibdPage() {
        const year = get(ibdPageData, 'year', '');
        omniture = extend({}, omniture, {
          channel: 'ibd',
          pageName: year ? `${siteSlug}:ibd:${year}` : `${siteSlug}:ibd:front`,
          pageURL: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
          url: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:page:ibd`,
          prop28: 'ibd',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      productIndexSectionPage() {
        omniture = extend({}, omniture, {
          channel: 'product',
          pageName: `product:homepage:front`,
          pageURL: `${get(siteConfig, 'url')}/stuff`,
          url: `${get(siteConfig, 'url')}/stuff`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/stuff`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:ibd:homepage:front`,
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      productIndexPage() {
        omniture = extend({}, omniture, {
          channel: 'product',
          pageName: `product:homepage:front`,
          pageURL: `${get(siteConfig, 'url')}/stuff`,
          url: `${get(siteConfig, 'url')}/stuff`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/stuff`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:ibd:homepage:front`,
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      productPage() {
        const productName = get(productPageData, 'data.rows[0].name');
        const productSlug = get(productPageData, 'data.rows[0].url');

        omniture = extend({}, omniture, {
          channel: 'product',
          pageName: `product:${productSlug}`,
          pageURL: `${get(siteConfig, 'url')}/product/${productSlug}`,
          url: `${get(siteConfig, 'url')}/product/${productSlug}`,
          prop1: '',
          prop2: '',
          prop3: `Product: ${productName}`,
          prop4: `${get(siteConfig, 'url')}/product/${productSlug}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:product:${productSlug}`,
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      companyPage() {
        const companyURL = get(companyPageData, 'data.rows[0].url', '');
        omniture = extend({}, omniture, {
          channel: 'company',
          pageName: `anonymous:company:profile:${companyURL}`,
          pageURL: `${get(siteConfig, 'url')}/company/${companyURL}`,
          url: `${get(siteConfig, 'url')}/company/${companyURL}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/company/${companyURL}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:company:profile:${companyURL}`,
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      companyIndexSectionPage() {
        omniture = extend({}, omniture, {
          channel: 'company',
          pageName: 'company:index',
          pageURL: `${get(siteConfig, 'url')}/company`,
          url: `${get(siteConfig, 'url')}/company`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/company`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:company:index`,
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      micYearPage() {
        const year = get(micPageData, 'year', '');
        omniture = extend({}, omniture, {
          channel: 'mic',
          pageName: year ? `${siteSlug}:mic:${year}` : `${siteSlug}:mic:front`,
          pageURL: `${get(
            siteConfig,
            'url'
          )}/most-innovative-companies/${year}`,
          url: `${get(siteConfig, 'url')}/most-innovative-companies/${year}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/most-innovative-companies/${year}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:mic`,
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      micSectorPage() {
        const year = get(micSectorPageData, 'year', '');
        const sector = get(micSectorPageData, 'sector', '');

        omniture = extend({}, omniture, {
          channel: 'mic',
          pageName: `${siteSlug}:mic:${year}:${sector}`,
          pageURL: `${get(
            siteConfig,
            'url'
          )}/most-innovative-companies/${year}/${sector}`,
          url: `${get(
            siteConfig,
            'url'
          )}/most-innovative-companies/${year}/${sector}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(
            siteConfig,
            'url'
          )}/most-innovative-companies/${year}/${sector}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:${siteSlug}:mic:${year}:${sector}`,
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      videoPage() {
        const currentVideoData = get(videoPageData, 'data.playlist[0]', null);
        if (!currentVideoData) {
          return;
        }

        const videoPageTag = get(currentVideoData, 'category');
        const postID = get(currentVideoData, 'id');

        // Extend original omniture variable
        omniture = extend({}, omniture, {
          pageName: `${siteSlug}:${postID}:${get(currentVideoData, 'slug')}`,
          channel: 'video',
          prop1: 'video',
          prop2: 'video',
          prop3: get(currentVideoData, 'title'),
          prop4: get(currentVideoData, 'link'),
          prop5: videoPageTag,
          prop6: videoPageTag,
          prop7: '',
          prop8: 'FastCo Studios',
          prop9: get(currentVideoData, 'omnitureDate'),
          prop10: postID,
          prop11: 'FastCo Studios',
          prop22: `anonymous:${siteSlug}:${postID}:${get(
            currentVideoData,
            'slug'
          )}`,
          prop28: 'video',
          prop31: '',
          prop32: '',
          prop33: capitalize('video')
        });
      },
      videoIndexPage() {
        omniture = extend({}, omniture, {
          channel: 'video',
          pageName: `fastcompany:video:front`,
          pageURL: `https://www.fastcompany.com/videos`,
          url: `https://www.fastcompany.com/videos`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `https://www.fastcompany.com/videos`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:fastcompany:video:front`,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      videoPlaylistPage() {
        const { feedid, slug } = playlistAllFeedData;
        omniture = extend({}, omniture, {
          channel: 'video',
          pageName: `fastcompany:video-playlist:${slug}`,
          pageURL: `https://www.fastcompany.com/videos/playlist/${slug}/${feedid}`,
          url: `https://www.fastcompany.com/videos/playlist/${slug}/${feedid}`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `https://www.fastcompany.com/videos/playlist/${slug}/${feedid}`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: `anonymous:fastcompany:video-playlist:${slug}`,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      },
      magazineArchivePage() {
        omniture = extend({}, omniture, {
          channel: 'magazine',
          pageName: 'magazine:magazine-archives:front',
          pageURL: `${get(siteConfig, 'url')}/magazine/archives`,
          url: `${get(siteConfig, 'url')}/magazine/archives`,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: `${get(siteConfig, 'url')}/magazine/archives`,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:magazine:archives:front',
          prop28: 'magazine',
          prop31: '',
          prop32: '',
          prop33: ''
        });
      }
    };

    if (typeLookup[type]) {
      typeLookup[type]();
    }

    map(omniture, (value, key) => {
      window.fastco_s[key] = value;
    });

    // Track page number
    //     if (pageNumber) {
    //       // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    //       window.fastco_s.linkTrackVars = 'events';
    //       window.fastco_s.linkTrackEvents = 'event31';
    //       window.fastco_s.events = 'event31';
    //       window.fastco_s.tl(this, 'o', pageNumber);
    //     }

    window.fastco_s.t();
  }
}

export function trackOmniture(sEvent, sValue) {
  if (canUseDOM) {
    if (!window.fastco_s) {
      // console.error('Omniture not initialized, please include omniture s_code.js');
      return;
    }

    if (!sEvent || !sValue) {
      // console.error('Tracking parameters not provided');
      return;
    }

    // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
  }
}
